import { useTranslation } from 'react-i18next';
import { UploadOutlined, InboxOutlined, EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import { useEffect, useRef, useState } from 'react';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { InputNumber } from '@app/components/common/inputs/InputNumber/InputNumber';
import { BaseSelect, Option } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseSwitch } from '@app/components/common/BaseSwitch/BaseSwitch';
import { BaseRadio } from '@app/components/common/BaseRadio/BaseRadio';
import { BaseSlider } from '@app/components/common/BaseSlider/BaseSlider';
import { BaseUpload } from '@app/components/common/BaseUpload/BaseUpload';
import { BaseRate } from '@app/components/common/BaseRate/BaseRate';
import { notificationController } from '@app/controllers/notificationController';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseCheckbox } from '@app/components/common/BaseCheckbox/BaseCheckbox';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import config from '@app/config';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { createInternalUserAction, createProductAction, getAllCategoriesAction } from '@app/store/slices/userSlice';
import { useNavigate } from 'react-router-dom';
import { returnArea } from '@app/utils/utils';
import { Form, Upload } from 'antd';
import { InputPassword } from '@app/components/common/inputs/InputPassword/InputPassword.styles';
import { readUser } from '@app/services/localStorage.service';

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};



export const ValidationFormUserAdd: React.FC<any> = (props) => {
  const formRef = useRef<any>();
  const [isFieldsChanged, setFieldsChanged] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [fileIdDocs, setFileIdDocs] = useState(null);
  const [categories, setAllCategories] = useState([]);
  const [fileId, setFileId] = useState(null);
  const [formReset, setFormReset] = useState(false);

  const user=readUser();

  useEffect(() => {

    dispatch(getAllCategoriesAction()).unwrap().then((resp) => {

      if (resp) {
        setAllCategories(resp.data);
      }


    }).catch((err: any) => {
      notificationController.error({ message: err.message });
    })

  }, [])






  const onFinish = async (values: any) => {
    setLoading(true);


    setFieldsChanged(false);

    console.log(values);
    values.password='Password@123'
    if(!values.isActive) values.isActive=false;
    dispatch(createInternalUserAction(values))
      .unwrap()
      .then((resp: any) => {
        setLoading(false);
        if (resp.success) {
          notificationController.success({ message: t('common.success') });

          navigate('/admin/users/list');
        }
        else {
          notificationController.error({ message: 'Failed to save user' });
        }

      }).catch((err: any) => {
        setLoading(false);
        notificationController.error({ message: err.message });
      })


  };




  return (
    <>

      {!isLoading && <Form
        className='clinic-onboard-form'
        {...formItemLayout}
        ref={formRef}
        name="validateForm"
        initialValues={{}}

        onFinish={onFinish}
      >

        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12} >
            <BaseButtonsForm.Item
              name="firstName"
              label={"First Name"}
              rules={[{ required: true, message: "First Name is required" }]}
            >
              <BaseInput />
            </BaseButtonsForm.Item>
          </BaseCol>
          <BaseCol xs={24} sm={12} >
            <BaseButtonsForm.Item
              name="lastName"
              label={"Last Name"}
              rules={[{ required: true, message: "Last Name is required" }]}
            >
              <BaseInput />
            </BaseButtonsForm.Item>
          </BaseCol>
          <BaseCol xs={24} sm={12} >
            <BaseButtonsForm.Item
              name="email"
              label={"Email"}
              rules={[{ required: true, message: "Email is required" }]}
            >
              <BaseInput />
            </BaseButtonsForm.Item>
          </BaseCol>


          {user.role == 'Admin' && <BaseCol xs={24} sm={12} >
            <BaseButtonsForm.Item
              name="role"
              label={"Role"}
              rules={[{ required: true, message: "Role is required" }]}
            >
              <BaseSelect placeholder={"Please select a role"}>


                <Option value={'Admin'}>{"Admin"}</Option>
                <Option value={'Analyst'}>{"Analyst"}</Option>



              </BaseSelect>
            </BaseButtonsForm.Item>
          </BaseCol>
          }


          {!props.outer && <BaseCol xs={24} sm={12} md={8} >
            <BaseButtonsForm.Item name="isActive" label="Status" valuePropName="checked">
              <BaseSwitch />
            </BaseButtonsForm.Item>


          </BaseCol>
          }
        </BaseRow>

        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12} md={12} xl={6}>
            <BaseButtonsForm.Item>
              <BaseButton type="primary" htmlType="submit" loading={isLoading}>
                {t('common.submit')}
              </BaseButton>
            </BaseButtonsForm.Item>
          </BaseCol>
        </BaseRow>
      </Form>
      }
    </>
  );
};
